<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h3 
                    class="font-weight-bolder text-gradient"
                    :style="{ backgroundImage: `linear-gradient(310deg, ${themeColor}, ${themeColor}cc)` }"
                  >
                    Welcome back
                  </h3>
                  <p class="mb-0">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleSubmit" role="form" class="text-start">
                    <label>Email</label>
                    <soft-input type="email" placeholder="Email" id="email" v-model="user.email" />
                    <div v-if="emailError" class="error-message">
                      {{ emailError }}
                    </div>
                    <label>Password</label>
                    <soft-input id="password" type="password" placeholder="Password" v-model="user.password" />
                    <div v-if="passwordError" class="error-message">
                      {{ passwordError }}
                    </div>
                    
                    <div class="text-center">
                      <soft-button 
                        class="my-4 mb-2" 
                        variant="gradient" 
                        :style="{ backgroundColor: themeColor, borderColor: themeColor }"
                        full-width 
                        type="submit"
                        :disabled="loading"
                      >
                        <span v-if="!loading">Sign in</span>
                        <span v-else>Loading...</span>
                      </soft-button>
                    </div>
                  </form>

                  <div v-if="error" class="alert alert-danger mt-2">
                    {{ error }}
                  </div>

                  <div v-if="showTable && devices.length > 0">
                    <table>
                      <thead>
                        <tr>
                          <th>Device Name</th>
                          <th>Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="device in devices" :key="device.id">
                          <td>{{ device.device_info.browser }}</td>
                          <td>{{ device.device_type }}</td>
                          <td><button @click="logout(device.id)" class="logout-button">Logout</button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <button v-if="showTable && devices.length > 0" @click="cancel" class="cancel-button">Cancel</button>

                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8">
                <div class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6" :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/img/curved-images/curved9.jpg') +
                    ')',
                }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SoftInput from "@/components/SoftInput.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import axios from 'axios';
import UsersDataService from "../services/UsersDataService";
import RolesDataService from "../services/RolesDataService.js";

export default {
  name: "SignIn",
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      devices: [],
      error: "",
      emailError: "",
      passwordError: "",
      loading: false,
      showTable: true,
      themeColor: localStorage.getItem('themeColor') || '#2dce89'
    };
  },
  components: {
    SoftInput,
    SoftButton,
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
    this.applyTheme(this.themeColor);
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    
    applyTheme(color) {
      document.documentElement.style.setProperty('--primary-theme-color', color);
      document.documentElement.style.setProperty('--bs-success', color);
      document.documentElement.style.setProperty('--bs-primary', color);

      let styleTag = document.getElementById('dynamic-admin-theme');
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'dynamic-admin-theme';
        document.head.appendChild(styleTag);
      }

      styleTag.innerHTML = `
        .navbar-vertical .navbar-nav .nav-link.active .icon-shape {
          background-color: ${color} !important;
        }
        .bg-gradient-success {
          background-image: linear-gradient(310deg, ${color} 0%, ${color} 100%) !important;
        }
        .btn-success, .btn-gradient-success {
          background-color: ${color} !important;
          border-color: ${color} !important;
        }
        .text-success { color: ${color} !important; }
        .nav-link.active .nav-link-text { color: ${color} !important; }
      `;
    },

    async handleSubmit() {
      this.emailError = ""; 
      this.passwordError = ""; 
      this.error = ""; 

      if (!this.user.email) {
        this.emailError = "Email is required.";
      }
      if (!this.user.password) {
        this.passwordError = "Password is required.";
      }

      if (this.emailError || this.passwordError) {
        return;
      }

      this.loading = true; 

      try {
        const requestData = {
          email: this.user.email,
          password: this.user.password,
          device_info: 'web'
        };

        const config = { headers: { 'Content-Type': 'application/json' } };
        
        // 1. Get the URL from environment variable
        // 2. Fallback to hardcoded URL if env is undefined to prevent URL/undefined/ errors
        const baseUrl = process.env.VUE_APP_API_BASE_URL ;
        
        // 3. Perform the login request to the Backend server
        const response = await axios.post(`${baseUrl}/v1/admin/auth/login`, 
          requestData, 
          config
        );

        const token = response.data.accessToken || response.data.token;
        const user = response.data.user || response.data.admin || {};
        const isMediaUser = response.data.is_media_user;
        
        if (!token) {
          this.error = response.data.msg;
          this.showTable = true;
          this.$router.push({ name: 'Sign In' });
        } else {
          // Clear previous tenant's stale cached session keys
          localStorage.removeItem('tenant_name');
          localStorage.removeItem('company_name');
          localStorage.removeItem('tenantName');
          localStorage.removeItem('companyName');
          localStorage.removeItem('doctorShiftSession');
          localStorage.removeItem('doctorRoom');
          localStorage.removeItem('doctorDepartment');
          localStorage.removeItem('department');
          localStorage.removeItem('doctor_status');

          const userColor = user.theme_color || response.data.theme_color || '#2dce89';
          localStorage.setItem('token', token);
          localStorage.setItem('id', user.id || response.data.id);
          localStorage.setItem('userName', user.name || response.data.name || 'User');
          localStorage.setItem('adminEmail', user.email || response.data.email);
          localStorage.setItem('themeColor', userColor);
          localStorage.setItem('user', JSON.stringify(user));

          const incomingTenant = user.company_name || user.tenant_name || user.hospital_name || response.data.company_name || response.data.tenant_name || '';
          if (incomingTenant) {
            localStorage.setItem('tenant_name', incomingTenant);
            localStorage.setItem('company_name', incomingTenant);
          }

          const userDept = user.department || user.department_name || user.branch_name || (user.branch && user.branch.branch_name) || (user.Branch && user.Branch.branch_name) || user.speciality || user.specialization || '';
          if (userDept) {
            localStorage.setItem('doctorDepartment', userDept);
            localStorage.setItem('department', userDept);
          }

          if (response.data.systemModules) {
            localStorage.setItem('systemModules', JSON.stringify(response.data.systemModules));
          }
          
          let roleSlug = '';
          if (user.role_name) {
             roleSlug = String(user.role_name);
          } else if (user.role_slug) {
             roleSlug = String(user.role_slug);
          } else if (user.roleName) {
             roleSlug = String(user.roleName);
          } else if (user.role) {
             if (typeof user.role === 'string') {
                roleSlug = user.role;
             } else if (user.role.name) {
                roleSlug = user.role.name;
             } else if (user.role.role_name) {
                roleSlug = user.role.role_name;
             } else if (user.role.slug) {
                roleSlug = user.role.slug;
             }
          } else if (response.data.role) {
             if (typeof response.data.role === 'string') {
                roleSlug = response.data.role;
             } else if (response.data.role.name) {
                roleSlug = response.data.role.name;
             }
          } else if (response.data.role_name) {
             roleSlug = String(response.data.role_name);
          } else if (response.data.user_role) {
             roleSlug = String(response.data.user_role);
          } else if (response.data.userRole) {
             roleSlug = String(response.data.userRole);
          }

          if (!roleSlug) {
             if (isMediaUser) {
                roleSlug = 'mediauser';
             } else {
                roleSlug = 'admin';
             }
          }

          roleSlug = roleSlug.toLowerCase().replace(/\s+/g, '');
          localStorage.setItem('userRole', roleSlug);

          let instRaw = user.installation_type_name || user.installation_type || response.data.installation_type_name || response.data.installation_type || user.installation_type_id || response.data.installation_type_id || user.type || '';
          if (typeof instRaw === 'object') {
             instRaw = instRaw.name || instRaw.title || instRaw.code || '';
          }
          let instStr = String(instRaw).toLowerCase();
          if (instStr === '2' || instStr === '5') instStr = 'medical';
          else if (instStr === '1' || instStr === '6') instStr = 'media';

          localStorage.setItem('installationType', instStr);
          localStorage.setItem('installation_type_id', String(user.installation_type_id || response.data.installation_type_id || user.type || ''));

          let rawModules = [];
          if (user.role && typeof user.role === 'object') {
             if (Array.isArray(user.role.permissions)) {
                rawModules = rawModules.concat(user.role.permissions);
             } else if (typeof user.role.permissions === 'string') {
                try { rawModules = rawModules.concat(JSON.parse(user.role.permissions)); } catch(e) { rawModules.push(user.role.permissions); }
             }
             if (Array.isArray(user.role.modules)) {
                rawModules = rawModules.concat(user.role.modules);
             } else if (typeof user.role.modules === 'string') {
                try { rawModules = rawModules.concat(JSON.parse(user.role.modules)); } catch(e) { rawModules.push(user.role.modules); }
             }
          }
          if (user.permissions && Array.isArray(user.permissions)) {
             rawModules = rawModules.concat(user.permissions);
          }
          if (user.modules && Array.isArray(user.modules)) {
             rawModules = rawModules.concat(user.modules);
          }
          const isAdminRole = roleSlug.includes('admin') || roleSlug.includes('superadmin');
          if (isAdminRole) {
             if (response.data.permissions && Array.isArray(response.data.permissions)) {
                rawModules = rawModules.concat(response.data.permissions);
             }
             if (response.data.modules && Array.isArray(response.data.modules)) {
                rawModules = rawModules.concat(response.data.modules);
             }
          }
          
          if ((!rawModules || rawModules.length === 0) && (user.role_id || user.role || user.role_name)) {
             try {
                const rolesRes = await RolesDataService.getAll();
                const rolesList = Array.isArray(rolesRes.data) ? rolesRes.data : (rolesRes.data && rolesRes.data.data ? rolesRes.data.data : []);
                const targetRoleId = user.role_id || user.roleId || user.role_slug || user.role;
                const matchedRole = rolesList.find(r => 
                   (targetRoleId && (r.id == targetRoleId || r.role_id == targetRoleId)) ||
                   (r.name && user.role_name && r.name.toLowerCase().trim() === String(user.role_name).toLowerCase().trim()) ||
                   (r.name && user.role && r.name.toLowerCase().trim() === String(user.role).toLowerCase().trim())
                );
                if (matchedRole) {
                   rawModules = matchedRole.permissions || matchedRole.modules || matchedRole.RolePermissions || matchedRole.role_permissions || [];
                   console.log("Fetched fallback role modules:", rawModules);
                }
             } catch (err) {
                console.log("Error fetching fallback role modules:", err);
             }
          }

          // Fetch allowed modules from /v1/admin/me/modules for the Tenant Installation Type
          let instAllowedModules = [];
          try {
            const instId = localStorage.getItem('installation_type_id') || '';
            const meModulesRes = await axios.get(`${baseUrl}/v1/admin/me/modules?installation_type_id=${instId}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (meModulesRes.data && (meModulesRes.data.modules || meModulesRes.data.permissions)) {
              instAllowedModules = meModulesRes.data.modules || meModulesRes.data.permissions || [];
            }
          } catch (meErr) {
            console.log("Could not fetch /me/modules during login:", meErr.message);
          }

          // If rawModules is empty, default to Tenant Installation Type modules ONLY for superadmin / admin
          if ((!rawModules || rawModules.length === 0) && (roleSlug.includes('admin') || roleSlug.includes('superadmin'))) {
            rawModules = instAllowedModules;
          }

          let flattenedModules = [];
          if (typeof rawModules === 'string') {
            try { rawModules = JSON.parse(rawModules); } catch (e) { rawModules = [rawModules]; }
          }
          if (Array.isArray(rawModules)) {
            rawModules.forEach(m => {
              if (typeof m === 'string' && (m.startsWith('[') || m.startsWith('{'))) {
                try {
                  const parsed = JSON.parse(m);
                  if (Array.isArray(parsed)) flattenedModules.push(...parsed);
                  else flattenedModules.push(parsed);
                } catch (e) {
                  flattenedModules.push(m);
                }
              } else {
                flattenedModules.push(m);
              }
            });
            rawModules = flattenedModules;
          }

          // Strictly intersect role/user modules with the Tenant's Installation Type allowed modules (non-superadmins)
          if (Array.isArray(instAllowedModules) && instAllowedModules.length > 0 && !roleSlug.includes('superadmin')) {
            const expandedInstKeys = new Set();
            instAllowedModules.forEach(item => {
              if (item !== undefined && item !== null) {
                if (typeof item === 'object') {
                  ['id', 'module_id', 'code', 'name', 'slug', 'module_name'].forEach(k => {
                    if (item[k] !== undefined && item[k] !== null) {
                      const str = String(item[k]).toLowerCase().trim();
                      expandedInstKeys.add(str);
                      expandedInstKeys.add(str.replace(/[^a-z0-9]/g, ''));
                    }
                  });
                } else {
                  const rawStr = String(item).toLowerCase().trim();
                  expandedInstKeys.add(rawStr);
                  expandedInstKeys.add(rawStr.replace(/[^a-z0-9]/g, ''));
                }
              }
            });

            rawModules = rawModules.filter(m => {
              if (m === undefined || m === null) return false;
              let itemKeys = [];
              if (typeof m === 'object') {
                ['id', 'module_id', 'code', 'name', 'slug', 'module_name'].forEach(k => {
                  if (m[k] !== undefined && m[k] !== null) {
                    itemKeys.push(String(m[k]).toLowerCase().trim());
                  }
                });
              } else {
                let strVal = String(m).toLowerCase().trim();
                if (strVal.includes(':')) {
                  strVal = strVal.split(':')[0].trim();
                }
                itemKeys.push(strVal);
              }

              return itemKeys.some(k => expandedInstKeys.has(k) || expandedInstKeys.has(k.replace(/[^a-z0-9]/g, '')));
            });
          }

          if (Array.isArray(rawModules) && rawModules.length > 0) {
             const moduleNames = rawModules.map(m => (typeof m === 'object' && m !== null ? (m.module_name || m.name || m.code || m.id) : m));
             localStorage.setItem('allowedModules', JSON.stringify(moduleNames));
             localStorage.setItem('userModules', JSON.stringify(rawModules));
          } else {
             localStorage.setItem('allowedModules', JSON.stringify([]));
             localStorage.setItem('userModules', JSON.stringify([]));
          }
          
          this.themeColor = userColor; 
          this.applyTheme(userColor); 
          
          const currentRole = (localStorage.getItem('userRole') || '').toLowerCase();
          if (currentRole === 'doctor' || instStr.includes('medical')) {
            this.$router.push('/medical-dashboard');
          } else {
            this.$router.push({ name: 'Dashboard' });
          }
          this.showTable = false;
        }
      } catch (error) {
        console.error("Login Error:", error);
        if (error.response && error.response.data && error.response.data.msg) {
          this.error = error.response.data.msg;
        } else {
          this.error = 'An error occurred. Please check your backend CORS settings.';
        }
        this.$router.push({ name: 'Sign In' });
      } finally {
        this.loading = false;
      }
    },
    async logout(deviceId) {
      this.loading = true;
      try {
        await UsersDataService.delete(deviceId);
        const preservedKeys = ['hospitalDoctorShifts', 'doctorShiftSession', 'doctorDepartment', 'doctorRoom', 'themeColor'];
        const preservedData = {};
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && (preservedKeys.includes(k) || k.startsWith('doctorShift_') || k.startsWith('hospital_'))) {
            preservedData[k] = localStorage.getItem(k);
          }
        }
        localStorage.clear();
        Object.keys(preservedData).forEach(k => {
          localStorage.setItem(k, preservedData[k]);
        });
        await this.handleSubmit();
      } catch (error) {
        console.log(error);
        this.error = 'An error occurred while logging out. Please try again later.';
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.emailError = "";
      this.passwordError = "";
      this.error = ""; 
      this.user.email = "";
      this.user.password = "";
      this.showTable = false;
    }
  },
};
</script>

<style scoped>
.text-gradient {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.error-message { color: #e74c3c; font-size: 0.875rem; margin-top: 0.5rem; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
th { background-color: #f2f2f2; }
.logout-button { background-color: #ff4d4d; color: white; border: none; padding: 8px 16px; cursor: pointer; border-radius: 4px; }
.logout-button:hover { background-color: #ff1a1a; }
.cancel-button { background-color: #f44336; color: white; border: none; padding: 10px 20px; text-align: center; text-decoration: none; display: inline-block; font-size: 16px; margin: 4px 2px; cursor: pointer; border-radius: 4px; }
</style>